import styled from 'styled-components';

export const RiftTourColumnImage = styled.img`
  height: auto;
  max-width: 100%;
  width: 100%;
`;
